import { motion } from 'framer-motion';
import { ClockIcon, MegaphoneIcon } from '@heroicons/react/24/outline';

const NewsSection = () => {

  return (
    <div className="py-16 bg-primary/10">
      <div className="container mx-auto px-4">
        <motion.div
          className="bg-white rounded-2xl shadow-elegant overflow-hidden"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="flex flex-col lg:flex-row">
            {/* Left side - Illustration */}
            <div className="lg:w-1/3 bg-primary p-8 flex items-center justify-center">
              <div className="text-center">
                <MegaphoneIcon className="h-24 w-24 mx-auto text-white mb-4" />
                <h2 className="text-white text-5xl font-bold">NOUVEAUTÉ !</h2>
                <p className="text-white/90 text-lg font-semibold mt-2">جديد</p>
              </div>
            </div>

            {/* Right side - Information */}
            <div className="lg:w-2/3 p-6 md:p-10">
              <div className="flex items-center gap-3 mb-3">
                <ClockIcon className="h-10 w-10 text-primary flex-shrink-0" />
                <div>
                  <h3 className="text-gray-900 text-2xl md:text-3xl font-bold leading-tight">Horaire Continu au Lycée</h3>
                  <h3 className="text-gray-700 text-lg md:text-xl font-semibold" dir="rtl">التوقيت المستمر بالثانوي</h3>
                </div>
              </div>

              <div className="inline-flex items-center gap-2 bg-primary/15 border border-primary/30 rounded-full px-4 py-1.5 mb-3">
                <span className="text-base md:text-lg font-bold text-primary-dark">8h30 – 16h30</span>
              </div>

              <p className="text-sm md:text-base text-gray-700">
                Le Lycée passe à l'horaire continu de <strong>8h30 à 16h30</strong> à partir de la rentrée <strong>2026-2027</strong>.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default NewsSection;
